export default __webpack_public_path__ + "assets/github.91dbce7a.svg";